import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  List,
  ListItem,
} from "@mui/material";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  contactMethods,
  optoutind,
  autoassess,
  isLoading,
  selectCommsMethodAsync,
} from "../../features/AppSlice";
import { useForm, useFormState } from "react-final-form";
import AssessmentSwitch from "../usercomponents/AssessmentSwitch";
const ContactTypes = ["SMS", "Email"];

const AssessmentResult = () => {
  const formstate = useFormState();
  const contactOptions = useSelector(contactMethods);
  const optout = useSelector(optoutind);
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const form = useForm();

  console.log("methodindex " + formstate.values?.methodindex);

  const handleSelect = async (index) => {
    if (!loading) {
      console.log("index " + index);
      form.change("methodindex", index);
      await dispatch(selectCommsMethodAsync());
    }
  };

  const autoAssess = useSelector(autoassess);

  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardHeader
          title={autoAssess}
          sx={{ color: "primary.main" }}
        ></CardHeader>
      </Card>

      {optout == 1 ? (
        <Card>
          <CardContent>
            <AssessmentSwitch />
          </CardContent>
        </Card>
      ) : null}

      <Card
        sx={{
          height: "100%",
        }}
      >
        <CardContent>
          <Grid container columnSpacing={3.5} rowSpacing={0.5}>
            <Grid size={{ xs: 12 }}>
              <List
                component="nav"
                aria-label="Available Communication Methods"
                justifyContent="center"
              >
                {contactOptions?.map((option, index) => (
                  <ListItem key={index} alignItems="center">
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth={true}
                      size="medium"
                      sx={{
                        height: 80,
                        width: "100%",
                      }}
                      onClick={() => handleSelect(index)}
                    >
                      Click here to send this result as{" "}
                      {ContactTypes[option.type]} to {option.destinationMasked}.
                    </Button>
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default AssessmentResult;
